import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  detailsInitialState,
} from "../../../reducers/module/detailsReducer";
import Details from "./partials/details/Details";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import useConfirm from "../../../HOC/custom/useConfirm";
import OrderStatusModal from "./partials/details/OrderStatusModal";
import { loadItemGeneral } from "../../../helpers/ModuleHelperFunctions";

const ReturnView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [showOrderStatusModal, setShowOrderStatusModal] = useState(false);
  const [status, setStatus] = useState(0);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    detailsInitialState
  );
  const navigate = useNavigate();
  let { id } = useParams();
  const { confirm } = useConfirm();
  const loadItem = async () => {
    await loadItemGeneral(id, `${moduleConfig.url}/${id}`, detailsDispatch);
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.details,
    ]);
  }, [id]);

  const confirmAndAction = async (id, status) => {
    //console.log(status, status === "1" || status === 1 ? "complete" : "cancel");
    const isConfirmed = await confirm(
      `Do you really want to ${
        status === "1" || status === 1 ? "accept" : "reject"
      } this return request?`
    );

    if (isConfirmed) {
      setStatus(status);
      setShowOrderStatusModal(true);
    }
  };

  return (
    <DashboardLayout>
      {detailsState.isFetching ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>
                  {(detailsState.data.item.status === "0" ||
                    detailsState.data.item.status === 0) && (
                    <div className="border mb-1 p-1 bg-light text-white rounded">
                      {(detailsState.data.item.status === "0" ||
                        detailsState.data.item.status === 0) && (
                        <Button
                          className="me-1 btn-custom-4 "
                          title={`Mark ${moduleConfig.singleItemTitle} as completed`}
                          onClick={() =>
                            confirmAndAction(detailsState.data.item._id, "1")
                          }
                        >
                          <i className="fas fa-check me-1"> </i>{" "}
                          <span className="">Accept Return</span>
                        </Button>
                      )}
                      {(detailsState.data.item.status === "0" ||
                        detailsState.data.item.status === 0) && (
                        <Button
                          className="btn-custom-3 me-1 "
                          variant="danger"
                          title={`Reject return`}
                          onClick={() =>
                            confirmAndAction(detailsState.data.item._id, "2")
                          }
                        >
                          <i className="fas fa-times me-1"> </i>{" "}
                          <span className="">Reject Return</span>
                        </Button>
                      )}
                    </div>
                  )}

                  <Details
                    item={detailsState.data.item}
                    moduleConfig={moduleConfig}
                  />

                  <OrderStatusModal
                    show={showOrderStatusModal}
                    setShow={setShowOrderStatusModal}
                    loadItem={loadItem}
                    id={detailsState.data.item._id}
                    status={status}
                    item={detailsState.data.item}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default ReturnView;
